<template>
  <div>
    <div class="foot-bg">
      <div class="banxin" style="display: flex;align-items: center;justify-content: space-between;">
        <div style="font-weight: 500;font-size: 15px;color: #333333;display: flex;flex-direction: column;gap: 20px;">
          <img src="@/assets/images/footLogo.svg" alt="" style="width: 346px;height: 107px;margin-bottom: 16px;"
            class="slide-image">
          <div>公司名称：呦步数字科技(北京)有限公司</div>
          <div>服务热线：187 0146 6986</div>
          <div>公司地址：北京市朝阳区光华路SOHO-1期-305室</div>
        </div>
        <div style="display: flex;gap: 46px;">
          <div style="text-align: center;">
            <img src="@/assets/images/wecode.png" alt="" style="width: 160px;height: 160px;margin-bottom: 27px;"
              class="slide-image">
            <div>公众号</div>
          </div>
          <div style="text-align: center;">
            <img src="@/assets/images/sph.png" alt="" style="width: 160px;height: 160px;margin-bottom: 27px;"
              class="slide-image">
            <div>视频号</div>
          </div>
          <div style="text-align: center;">
            <img src="@/assets/images/dyh.png" alt="" style="width: 160px;height: 160px;margin-bottom: 27px;"
              class="slide-image" />
            <div>抖音号</div>
          </div>
          <div style="text-align: center;">
            <img src="https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E5%BA%95%E9%83%A8%E5%B0%8F%E7%BA%A2%E4%B9%A6.png" alt="" style="width: 160px;height: 160px;margin-bottom: 27px;"
              class="slide-image">
            <div>小红书</div>
          </div>
        </div>
      </div>
      <div class="banxin2" style="height: 282px;padding-top: 62px;display: flex;justify-content: space-between;">
        <img src="@/assets/images/footLogo.svg" alt="" style="width: 150px;height: 47px;" class="slide-image">
        <div>
          <div class="foot-title" >关于呦步</div>
          <div class="foot-text curPot" @click="handleNav('/about?index=0&id=box-1-m')">品牌介绍</div>
          <div class="foot-text curPot" @click="handleNav('/about?index=1&id=box-2-m')"> 品牌起源</div>
          <div class="foot-text curPot" @click="handleNav('/about?index=2&id=box-3-m')">企业文化</div>
          <div class="foot-text curPot" @click="handleNav('/about?index=3&id=box-4-m')">商业模式</div>
          <div class="foot-text curPot" @click="handleNav('/about?index=4&id=box-5-m')">我们的客户</div>

        </div>

        <div>
          <div class="foot-title">我们的产品</div>
          <div class="foot-text curPot" @click="handleNav('/detail?goodId=3')">进口生物力学雕刻款</div>
          <div class="foot-text curPot" @click="handleNav('/detail?goodId=2')">国产生物力学雕刻款</div>
          <div class="foot-text curPot" @click="handleNav('/detail?goodId=1')">3D生物力学打印款</div>
          <div class="foot-text curPot" @click="handleNav('/detail?goodId=4')">本体感觉肌脑训练款</div>
          <div class="foot-text curPot" @click="handleNav('/detail?goodId=5')">运动专项定制款</div>
        </div>

        <div>
          <div class="foot-title">一站式定制</div>
          <div class="foot-text curPot" @click="handleNav('/customization?id=0')">数字化检测评估流程</div>
          <div class="foot-text curPot" @click="handleNav('/customization?id=1')"> 一站式数字化定制服务</div>
          <div class="foot-text curPot" @click="handleNav('/customization?id=2')">支撑远程定制服务</div>
          <div class="foot-text curPot" @click="handleNav('/customization?id=3')">售后服务保障</div>

        </div>

        <div>
          <div class="foot-title">新闻中心</div>
          <div class="foot-text curPot"  @click="handleNav('/news')">公司动态</div>
          <div class="foot-text curPot"  @click="handleNav('/news')"> 媒体报道</div>
        </div>
        <div>
          <div class="foot-title">加入我们</div>
          <div class="foot-text curPot" @click="handleNav('/join')">城市合伙人计划</div>
        </div>
        <div >
              <div class="foot-title" >关注我们</div>
                
          <div style="display: flex;align-items: center;">
            <img src="@/assets/images/wecode.png" alt="" style="width: 160px;height: 160px;" class="slide-image">
             <div>
              <div class="foot-text">将始终秉承</div>
            <div class="foot-text">放心产品，用心服务的服务理念</div>
            <div class="foot-text">持续为客户创造价值</div>
             </div>

          </div>
        </div>
      </div>
    <div  style="height: 59px;font-weight: 500;font-size: 12px;color: #333333;line-height: 59px;border-top: 1px solid #D8D8D8;display: flex;justify-content: center;">
      <div
       >
        @ 呦步数字科技(北京)有限公司 版权信息
      </div>
      <div style="padding-left: 50px;cursor: pointer;" @click="handleNav('https://beian.miit.gov.cn/')">
        京公网安备 11010102000001号  <span style="padding-left: 10px;"> 京ICP备05070602号 </span>   
      </div>
   
    </div>
      
    </div>

  </div>
</template>

<script>
export default {
  // props: {
  //   menuIndex: { type: Number, default: 0 }
  // },
  data() {

  },
  methods:{
    handleNav(url){
      window.location.href=url
    },
    hanhandleNavGxb(url){
      window.open(url)
    }
  }


}
</script>

<style scoped>
.foot-title {
  font-weight: 800;
  font-size: 16px;
  color: #333333;
  padding-bottom: 27px;
}

.foot-text {

  font-weight: 500;
  font-size: 12px;
  color: #666666;
  line-height: 26px;
}

.banxin {
  width: 1200px;
  height: 397px;

  z-index: 11;
}
.banxin2{
    width: 1359px;
    margin: auto;
}

.foot-bg {
  background-image: url('@/assets/images/footbg.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 397px;
  z-index: 1;
}
</style>